import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import {AppService} from '../app.service';
import {TerminDetail} from '../model/TerminDetail';
import {Student} from '../model/Student';
import {Message} from '../model/message';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-termin-detail',
    templateUrl: './termin-detail.component.html',
    styleUrls: ['./termin-detail.component.css'],
    standalone: false
})
export class TerminDetailComponent implements OnInit {

  loading = true;
  message: Message;
  terminDetail: TerminDetail;
  nezverejneniCount = 0;
  studenti: Student[] = [];

  constructor(
    public dialogRef: MatDialogRef<TerminDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {message: Message},
    private http: HttpClient,
    private appService: AppService,
    private translation: TranslateService
  ) { }

  ngOnInit(): void
  {
    this.message = this.data.message;

    const url = '/ais/rest/portal/student-predmety/termin-detail-message/' + this.message.id;

    this.http.get<TerminDetail>(url)
      .subscribe({
        next: (data) => {
          this.terminDetail = data;
          if (this.terminDetail.studenti) {
            this.terminDetail.studenti.forEach((s) => {
              if (s.plneMeno === 'unknown') {
                this.nezverejneniCount++;
              } else {
                this.studenti.push(s);
              }
            });
          }
          this.loading = false;
        },
        error: (error) => {
          this.loading = false;
          this.appService.openErrorDialog(this.translation.instant(error.error.message));
          this.dialogRef.close();
        }
      });
  }

  prihlasit()
  {
    const msg3 = this.translation.instant('Súhlasíte so zverejnením vášho mena v zozname prihlásených študentov?');

    const dialogRef3 = this.appService.openConfirmDialogReturnsDialog(msg3);

    dialogRef3.afterClosed().subscribe(
        (res3) => {

            if (res3 === undefined) {
                return;
            }

          this.http.post(
              '/ais/rest/portal/student-predmety/termin-message/' + this.message.id,
              null,
              {
                params: {
                  zverejnit: (res3 === 'OK' ? 'true' : 'false')
                }
              }
          )
          .subscribe({
            next: () => {
              dialogRef3.close();
              this.appService.openSnackBar(
                  this.translation.instant('Boli ste prihlásený na termín')
              );
            },
            error: (error) => {
              this.appService.openErrorDialog(error.error.message);
            }
          });
        });
  }

}
